export default __webpack_public_path__ + "static/media/hexagon overlay.023a123d.svg";